import React from 'react'
import ProjectCards from '../ProjectCards'
import Footer from '../Footer'

function Projects() {
  return (
    <div>
      <ProjectCards/>
      <Footer/>
    </div>
  )
}

export default Projects
